import useApiRequest from 'api/useApiRequest';
import { querySearchContent, highlightSearchContent } from 'api/services/searchService';

const useSearch = () => {
  const { request } = useApiRequest();

  const getSearchResults = async (params) => {
    const { data } = await querySearchContent(request, params);
    return data;
  };

  const getHighlightedContent = async (params) => {
    const { data } = await highlightSearchContent(request, params);
    return data;
  };

  return { getSearchResults, getHighlightedContent };
};

export default useSearch;
